import { createFileRoute } from "@tanstack/react-router";

import {
  calendarSearchSchema,
  getCalendarInitialView,
} from "src/lib/calendarViewRoute";
import { loaderHandler } from "src/lib/loaderHandler";
import { AthleteCalendarPage } from "src/pages/AthleteCalendarPage";
import {
  fetchCalendarInitialData,
  OWN_CALENDAR_SOURCE,
} from "src/queries/calendar";

export const Route = createFileRoute("/_auth/_athlete/calendar/")({
  component: RouteComponent,
  validateSearch: calendarSearchSchema,
  ssr: true,
  staticData: {
    getScrollRestoration: () => {
      return false;
    },
  },
  async loader({ location }) {
    return await loaderHandler(async () => {
      const calendar = getCalendarInitialView(location.href, "fixed");
      const initialData = await fetchCalendarInitialData(
        OWN_CALENDAR_SOURCE,
        calendar,
      );

      return { data: { calendar, initialData } };
    });
  },
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();
  return (
    <AthleteCalendarPage
      calendar={loaderData.data.calendar}
      initialData={loaderData.data.initialData}
    />
  );
}
